import { FC } from 'react';
import { ReactionSVGIcons } from '../../theme/Icons';
import { IReactionBtnCodes } from './ReactionButton';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    reaction: {
        gap: 6,
        display: 'flex',
        alignItems: 'center'
    },

    icon: {
        width: 24,
        height: 24,

        '& svg': {
            fill: 'var(--ion-color-step-750)'
        }
    },

    count: {
        fontSize: 14
    }
});

export type IReactionProps = {
    reaction: IReactionBtnCodes;
    hasReaction?: boolean;
    useReactedIcon?: boolean;
    large?: boolean;
    count?: number;
};

export const Reaction: FC<IReactionProps> = ({ reaction, hasReaction, useReactedIcon, large, count }) => {
    const classes = useStyles();
    const icon = ReactionSVGIcons[reaction];

    return (
        <div className={classes.reaction}>
            <div
                style={large ? {width: 32, height: 32} : undefined}
                className={classes.icon}
            >
                {hasReaction || useReactedIcon ? icon.reacted || icon.base : icon.base}
            </div>
            {count && <span data-type="reaction-count" className={classes.count}>{count}</span>}
        </div>
    );
};
